export const muiSvgIconTheme = {
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fill: 'none',
        width: 'fit-content',
        height: 'fit-content',
      },
    },
  },
};
